const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://ak6lv5kink.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://jimgx88gg0.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'hotfix/CV4-3159-team-relationships-parents',
    HOSTNAME: 'https://teams-service.dev.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://ff1aofwdkd.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;
